module.exports = __webpack_public_path__ + "img/EU.8d8b98f2.svg";